import ApiModelWithAuth from "../../../models/ApiModelWithAuth";
import Formatter from "../../../models/Formatter";

export class NodeFormatter extends Formatter {
    static CustomItem(data) {
        const item = {};
        // Группы прокси — набор, порядок сервер не гарантирует (pluck связи). Сортируем, чтобы
        // диф формы (contentProvider сравнивает массивы через JSON) не видел правки на пустом месте.
        if (Array.isArray(data.proxy_group_ids)) {
            item.proxy_group_ids = data.proxy_group_ids
                .map((id) => this.Int(id))
                .filter((id) => id !== null)
                .sort((a, b) => (a - b));
        }
        return item;
    }
}

// Ноды фермы: CRUD + оркестрация (probe/provision/deploy — POST-действия).
// ssh_secret сервер не возвращает; пусто на update = оставить прежний.
export default class ApiNode extends ApiModelWithAuth {
    pathDef = 'authorized/admin/nodes';
    formatterItem = NodeFormatter.Item;

    // POST-действие ноды через штатный механизм ApiModel (paths override) — не голый fetch.
    static __PostAction(path, params = {}) {
        const api = new this();
        api.__type = 'store';
        api.paths = { 'store': path };
        api.__params = params;
        api.formatterItem = null; // ответы действий — {ok, ...}, не запись
        return api;
    }

    // Синхронная SSH-проба железа ноды → {ok, result|error}.
    static Probe(id) {
        return this.__PostAction(`authorized/admin/nodes/${id}/probe`);
    }

    // Провижининг — синхронный нативный PHP-SSH (provision.sh + проба) → {ok, status|error}.
    static Provision(id) {
        return this.__PostAction(`authorized/admin/nodes/${id}/provision`);
    }

    // Стереть запиненный SSH host-key ноды из панельного known_hosts (нода переустановлена/
    // пересоздана хостером — старый ключ иначе выдаёт себя за "неверные креды") → {ok, status}.
    static ResetKnownHosts(id) {
        return this.__PostAction(`authorized/admin/nodes/${id}/reset-known-hosts`);
    }

    // Аудит ноды: ферма отдаёт факт по всем устройствам ноды — живы ли они и какой прокси стоит, —
    // панель сверяет со своим и ставит исправления (исполняют кроны). Ответ сразу —
    // {result, execute_id}; аудит этой ноды уже идёт — 409 {result: false, error}.
    static Health(id) {
        return this.__PostAction(`authorized/admin/nodes/${id}/health`);
    }

    // Деплой партии устройств по тарифу (синхронно, run.py install) → {ok, created:[...], errors:[...]}.
    // skip_limit — не смотреть на max_devices ноды (ручное добавление, «Установка устройств»);
    // stop_after_install — после установки сразу опустить контейнер. Оба необязательные.
    static Deploy(id, { device_type_id, count, skip_limit, stop_after_install }) {
        const params = { device_type_id, count };
        if (skip_limit !== undefined) params.skip_limit = skip_limit;
        if (stop_after_install !== undefined) params.stop_after_install = stop_after_install;

        return this.__PostAction(`authorized/admin/nodes/${id}/deploy`, params);
    }

    // Привести ферму ноды к заявленному: снести лишние (последние по ID), добрать недостающие
    // и пересобрать с нуля все оставшиеся по ВЫБРАННОМУ тарифу (один на всю ноду) →
    // {result, max_devices, device_type, removed:[...], created:[...], rebuilt:[...], errors:[...]}.
    static SyncDevices(id, { device_type_id }) {
        return this.__PostAction(`authorized/admin/nodes/${id}/sync-devices`, { device_type_id });
    }

    // Точечный запуск одного скрипта каталога (см. NodeScriptsController::SCRIPTS) →
    // {ok, ...}. extraParams — напр. {lan_ip} для 'vpn'.
    static RunScript(id, scriptName, extraParams = {}) {
        return this.__PostAction(`authorized/admin/nodes/${id}/scripts/${scriptName}`, extraParams);
    }

    // История запусков SSH-скриптов ноды (пагинация) → [{id, script_name, status, ...}].
    static Executes(id, params = {}) {
        const api = new this();
        api.__type = 'index';
        api.__responseIsArray = true;
        api.isCheckPagination = true;
        api.paths = { 'index': `authorized/admin/nodes/${id}/executes` };
        api.__params = params;
        api.formatterItem = null; // сырые поля с бэка (уже ISO8601 и т.п.), без форматтера записи ноды
        return api;
    }
}
